import { queryCommentMessages } from '@dinosband/bv-messenger-client'
import { Message } from '@dinosband/bv-messenger-schema'
import { _last } from '@dinosband/dbi-utils'

import { BvDataCenterContext } from '../../type'

const MessageChunkSize = 20
export class MyCommentMessages {

  _messages: Message[] = []
  moreData = true

  context: BvDataCenterContext

  constructor (context: BvDataCenterContext) {
    this.context = context
  }

  async init () {
    //
  }

  cleanup () {
    this._messages = []
    this.moreData = true
  }

  addMessage (message: Message) {
    this._messages = [message, ...this._messages]
  }

  async commentMessages () {
    if (!this.moreData) {
      return this._messages
    }
    if (MessageChunkSize <= this._messages.length) {
      return this._messages
    }
    await this.moreCommentMessages()
    return this._messages
  }

  async moreCommentMessages () {
    const client = await this.context.messengerClient.getClient()
    const userId = this.context.mainStore.userId
    const cursor = _last(this._messages)?.id
    const excludeChatRoomIds = [...new Set(this._messages.map((i) => i.chatRoomId))]
    const result = await queryCommentMessages(client, userId, MessageChunkSize, excludeChatRoomIds, cursor) ?? []
    this._messages = [...this._messages, ...result]
    this.moreData = result.length >= MessageChunkSize
    return result
  }

}
